const selectors = {
  chartRoot: '[data-garment-chart-modal]',
  tab: '[data-garment-chart-tab]',
  content: '[data-garment-chart-content]',
  mobileSelect: '[data-garment-tab-select]',
  units: '[data-garment-units]',
  unit: '[data-garment-unit]',
  unitBtn: '[data-garment-unit-btn]',
};

// Shared with snippets/size-guide-table.liquid so the fit guide and PDP remember one choice.
const UNIT_KEY = 'lof_size_unit';

// Applied to every chart on the page so the PDP and quick view guides stay in step.
function applyUnit(unit) {
  document.querySelectorAll(selectors.unit).forEach(el => {
    el.classList.toggle('hidden', el.dataset.garmentUnit !== unit);
  });
  document.querySelectorAll(selectors.unitBtn).forEach(btn => {
    const isActive = btn.dataset.garmentUnitBtn === unit;
    btn.setAttribute('aria-pressed', String(isActive));
    btn.classList.toggle('bg-black', isActive);
    btn.classList.toggle('text-white', isActive);
  });
}

export default class GarmentChartModal {
  constructor(container = document) {
    this.container = container;
    this.init();
  }

  init() {
    const chartRoots = this.container.querySelectorAll(selectors.chartRoot);

    chartRoots.forEach(chartRoot => {
      if (chartRoot.dataset.initialized === 'true') {
        return;
      }

      chartRoot.dataset.initialized = 'true';
      this.bindChart(chartRoot);
      this.bindUnits(chartRoot);
    });
  }

  // Liquid renders the market default (CM for Canada); a saved shopper choice overrides it.
  bindUnits(chartRoot) {
    if (!chartRoot.querySelector(selectors.units)) {
      return;
    }

    let saved = null;
    try {
      saved = localStorage.getItem(UNIT_KEY);
    } catch (err) {
      // Storage blocked (private mode) — keep the market default.
    }
    if (saved === 'in' || saved === 'cm') {
      applyUnit(saved);
    }

    chartRoot.querySelectorAll(selectors.unitBtn).forEach(btn => {
      btn.addEventListener('click', () => {
        const unit = btn.dataset.garmentUnitBtn;
        try {
          localStorage.setItem(UNIT_KEY, unit);
        } catch (err) {
          // Storage blocked — the toggle still works for this page.
        }
        applyUnit(unit);
      });
    });
  }

  bindChart(chartRoot) {
    const tabs = Array.from(chartRoot.querySelectorAll(selectors.tab));
    const contents = Array.from(chartRoot.querySelectorAll(selectors.content));
    const mobileSelect = chartRoot.querySelector(selectors.mobileSelect);

    const activateTab = tabId => {
      tabs.forEach(tab => {
        const isActive = tab.dataset.garmentChartTab === tabId;
        tab.classList.toggle('button--black', isActive);
      });

      contents.forEach(content => {
        const isActive = content.dataset.garmentChartContent === tabId;
        content.classList.toggle('hidden', !isActive);
      });

      if (mobileSelect && mobileSelect.value !== tabId) {
        mobileSelect.value = tabId;
      }
    };

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        activateTab(tab.dataset.garmentChartTab);
      });
    });

    if (mobileSelect) {
      mobileSelect.addEventListener('change', event => {
        activateTab(event.target.value);
      });
    }

    activateTab('tab-1');
  }
}
